/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Open_ConversationInputs */

const en_case_history_open_conversation = /** @type {(inputs: Case_History_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open conversation`)
};

const pt_br2_case_history_open_conversation = /** @type {(inputs: Case_History_Open_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir conversa`)
};

/**
* | output |
* | --- |
* | "Open conversation" |
*
* @param {Case_History_Open_ConversationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_open_conversation = /** @type {((inputs?: Case_History_Open_ConversationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Open_ConversationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_open_conversation(inputs)
	return pt_br2_case_history_open_conversation(inputs)
});